module.exports = __webpack_public_path__ + "img/BRCA2_DC.84658db9.png";